import { HTMLAttributes, PropsWithChildren, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

export const EntityControll = forwardRef<
  HTMLDivElement,
  PropsWithChildren<HTMLAttributes<HTMLDivElement>>
>(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={twMerge(
        'z-10 flex h-6 w-6 cursor-pointer items-center justify-center rounded-full text-[#ffffff]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})

EntityControll.displayName = 'EntityControll'
